import { memo } from 'react';
import GooglePassFront from './GooglePassFront';
import GooglePassBack from './GooglePassBack';
import { PreviewData } from '../../../../../store/types/template';

const GooglePassPreview = ({
  selectedPassTab,
  previewData,
  featuresSide,
}: {
  selectedPassTab: string;
  previewData: PreviewData;
  featuresSide: 'Front' | 'Back';
}) => {
  const effectiveSide =
    selectedPassTab === 'Features'
      ? (featuresSide ?? 'Front')
      : selectedPassTab;

  const notifOpen =
    previewData.focusedField === 'notificationHeader' ||
    /^notificationMessages\.\d+\.label$/.test(
      previewData.focusedField || ''
    );

  return (
    <>
      {effectiveSide === 'Front' && (
        <GooglePassFront
          previewData={previewData}
          createTemplate={true}
          notifOpen={notifOpen}
        />
      )}
      {effectiveSide === 'Back' && (
        <GooglePassBack
          previewData={previewData}
          createTemplate={true}
          notifOpen={notifOpen}
        />
      )}
    </>
  );
};

export default memo(GooglePassPreview);
